import router from '@/router'

/**
 * 带标题设置的路由跳转
 * @param {String|Object} to - 跳转目标（路由路径/路由对象）
 * @param {String} title - 目标页面标题
 */
export const pushWithTitle = (to, title) => {
  // 第一步：提前设置标题（核心！跳转前先改标题）
  document.title = title;

  // 兼容 iOS 微信标题缓存
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) && /MicroMessenger/i.test(navigator.userAgent)) {
    const iframe = document.createElement('iframe');
    iframe.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    iframe.style.display = 'none';
    iframe.onload = () => {
      setTimeout(() => {
        document.title = title; // 再次强制设置
        iframe.remove();
      }, 0);
    };
    document.body.appendChild(iframe);
  }

  // 第二步：执行路由跳转
  router.push(to).catch(err => {
    if (err.name !== 'NavigationDuplicated') console.error(err);
  });
};
